export enum ViolationGradeType {
    CLEAN = "CLEAN",
    MINOR_CONCERN = "MINOR_CONCERN",
    NEEDS_REVIEW = "NEEDS_REVIEW",
    ATTEMPTED_VIOLATION = "ATTEMPTED_VIOLATION",
    VIOLATION = "VIOLATION"
}